<template>
  <div name="demo-import-text">
  	import text
  </div>
</template>

<script>
export default {
  name: 'demo-import-text'
}
</script>


// WEBPACK FOOTER //
// demoImportText.vue?41f7677e